import { render, staticRenderFns } from "./sameCountCom.vue?vue&type=template&id=aa500d5e"
import script from "./sameCountCom.vue?vue&type=script&lang=js"
export * from "./sameCountCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports